import styled from 'styled-components';

export const NavigationWrapper = styled.div`
  overflow: hidden;
  background-color: var(--v3-black-2);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 11;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-top: 4px;
`;

const TAB_WRAPPER_COUNT = 4;
export const TabWrapper = styled.div<{
  tabsCount: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: ${props => (props.tabsCount === TAB_WRAPPER_COUNT ? '25%' : '20%')};
`;

export const TabName = styled.div<{
  isActive: boolean;
}>`
  font-size: 11px;
  color: var(--v3-text-color);
  line-height: 16px;
  text-transform: capitalize;
  text-align: center;

  ${props =>
    props.isActive &&
    `
    color: var(--v3-primary-6);
    font-weight: 600;
  `};
  padding-top: 3px;
`;
